import styled from 'styled-components';

export const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: #282E33;
    border-radius: 8px;
    width: 500px;
    max-width: 90%;
    max-height: 90vh;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
`;

export const ModalHeader = styled.div`
    padding: 16px;
    border-bottom: 1px solid #3B444C;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ModalTitle = styled.h3`
    margin: 0;
    color: #B6C2CF;
    font-size: 16px;
`;

export const ModalBody = styled.div`
    padding: 16px;
    overflow-y: auto;
    flex: 1;
`;

export const Form = styled.form`
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
`;

export const Input = styled.input`
    flex: 1;
    padding: 8px 12px;
    border: 2px solid #3B444C;
    border-radius: 3px;
    font-size: 14px;
    background: #22272B;
    color: #B6C2CF;

    &:focus {
        border-color: #579DFF;
        outline: none;
    }
`;

export const Button = styled.button`
    padding: 8px 16px;
    border-radius: 3px;
    font-size: 14px;
    cursor: pointer;
    background: #579DFF;
    border: none;
    color: white;

    &:hover:not(:disabled) {
        background: #398BFF;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const MembersList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const MemberItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    background: #22272B;
    border-radius: 3px;
`;

export const MemberInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: #B6C2CF;
`;

export const Avatar = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #3B444C;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: white;
`;

export const RoleSelect = styled.select`
    padding: 4px 8px;
    background: #3B444C;
    border: none;
    border-radius: 3px;
    color: #B6C2CF;
    font-size: 14px;

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px #579DFF;
    }
`;

export const RemoveButton = styled.button`
    padding: 4px 8px;
    background: transparent;
    border: none;
    color: #FF5630;
    cursor: pointer;
    font-size: 14px;
    border-radius: 3px;

    &:hover {
        background: rgba(255, 86, 48, 0.1);
    }
`;

export const ErrorMessage = styled.div`
    color: #FF5630;
    font-size: 14px;
    margin-top: 8px;
    padding: 8px;
    background: rgba(255, 86, 48, 0.1);
    border-radius: 3px;
`;